import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../mutations/MutationTypes';
import {RenameBaselineVersionInput, RenameBaselineVersionMutation} from './__generated__/RenameBaselineVersionMutation.graphql';

const mutation = graphql`
	mutation RenameBaselineVersionMutation($input: RenameBaselineVersionInput!) {
		renameBaselineVersion(input: $input) {
			project {
				id
				baselineVersions {
					id
					name
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RenameBaselineVersionInput>,
	onSuccess?: RelayOnCompleted<RenameBaselineVersionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<RenameBaselineVersionMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Version', 'Renamed');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
